<template>
  <ModalBase show-modal @close-modal="close" :overlay-scrollb="false" full-h class="invoice-design-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
            {{ $gettext('EDIT') }}
        </template>
        <template v-slot:title>
          {{ $gettext('Invoice design') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <EditDesign
        ref="edit-invoice-design"
        :invoice="preparedInvoice"
        :totals="getTotals()"
        :recipient="recipient"
        on-modal
        @saved="savedAndClose"
      />
    </template>
    <template v-slot:actions>
      <div style="display: flex; justify-content: space-between; gap: 0.5rem;">
        <GekkoButton 
          @click="close()"
          :text="$gettext('Close')"
          variant="light"
        />
        <div class="premium-badge--inline">
          <GekkoButton
            @click="saveChanges()"
            :text="$gettext('Save layout')"
          >
            <template v-slot:premium-badge>
              <GkBadge 
                icon="fa-solid fa-crown"
                icon-only
                type="premium"
                variant="light-ghost"
              />
            </template>
          </GekkoButton>
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters } from "vuex";

import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

import EditDesign from "@/components/invoices/EditDesign"

export default {
  name: "InvoiceDesignModal",
  components: {
    ModalBase,
    TitleBar,
    GekkoButton,
    LoadingSpinner,
    EditDesign
  },
  data () {
    return {
      totals: {},
      recipient: null,
    }
  },
  computed: {
    ...mapGetters({ 
      invoice: "invoices/getInvoice",
      currentCompany: "main/getCurrentCompany"
    }),
    preparedInvoice () {
      return JSON.parse(JSON.stringify(this.invoice))
    }
  },
  created () {
    this.setupData()
  },
  mounted () {
    document.body.classList.add('modal-on')
  },
  methods: {
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    setupData () {
      this.recipient = this.invoice.recipient_customer.id
      this.totals = { "vat_totals": [[0]], "subtotal": 0, "total": 0 }
    },
    getTotals () {
      const totals = {
        vat_totals: [],
        subtotal: 0,
        total: 0
      }
      let vat_totals = []
      if (this.invoice && this.invoice.invoice_lines) {
        vat_totals = this.getVatTotals()
        vat_totals = Object.entries(vat_totals).map(([key, value]) => [parseInt(key), value])
        totals.vat_totals = vat_totals
        totals.subtotal = this.invoice.subtotal_amount
        totals.total = this.invoice.total_amount
      }
      return totals
    },
    getVatTotals () {
      const vat_totals = {}
      this.invoice.invoice_lines.forEach(invoice_line => {
        if((invoice_line.amount > 0 || invoice_line.amount < 0) && !invoice_line.vat_exempt) {
          if (!vat_totals[invoice_line.tax_rate]) {
            vat_totals[invoice_line.tax_rate] = 0
          }
          if (this.invoice.line_amount_is_gross) {
            vat_totals[invoice_line.tax_rate] += Math.round(invoice_line.multiplier * invoice_line.amount * 100) / 100 - Math.round((invoice_line.multiplier * invoice_line.amount / ( 1 + invoice_line.tax_rate / 100)) * 100) / 100
          } else {
            vat_totals[invoice_line.tax_rate] += Math.round(invoice_line.multiplier * invoice_line.amount * (invoice_line.tax_rate / 100) * 100) / 100
          }
        }
      })
      return vat_totals
    },
    saveChanges () {
      if (!this.currentCompany.is_premium) {
        this.$store.commit('togglePremiumModal', 'web_invoices_design')
      } else {
        this.$refs['edit-invoice-design'].saveChanges()
      }
    },
    savedAndClose () {
      this.$emit('layout-updated')
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
.invoice-design-modal {
  font-size: 1rem;
  .gk-modal {
    .modal-content-wrap { 
      position: relative; 
      margin: -1rem;
      margin-bottom: 0;
      border-bottom: 1px solid $colorBorderDash;
      .os-host-overflow-y { padding-right: 0 !important; }
    }
  }
}
</style>